import { isLinkBankBrand, LINK_BANK_CARD_NAME, LINK_BANK_FEE_LABEL } from './stripeFee';

export type PaymentMethodType = 'bank_account' | 'zelle' | 'card';

export interface PaymentMethodDisplay {
  id: string;
  type: PaymentMethodType;
  name: string;
  // Optional secondary line (e.g. the Zelle destination email)
  detail?: string | null;
  // Card brand (e.g. 'visa') used to render the correct brand mark
  brand?: string | null;
  expMonth?: number | null;
  expYear?: number | null;
  isDefault: boolean;
  lastUsed?: string | null;
  // Only used for bank accounts today
  bankVerificationStatus?: 'verified' | 'pending';
  // Processing fee shown on the row when it differs from the usual card rate
  feeNote?: string | null;
}

const CARD_BRAND_LABELS: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'Amex',
  discover: 'Discover',
  jcb: 'JCB',
  diners: 'Diners Club',
  diners_club: 'Diners Club',
  unionpay: 'UnionPay',
};

/**
 * Name, expiry and fee note for a saved card row. A `link` card is a bank account paid
 * through Link: its last4 (0000) and expiry are placeholders, so show what it is and the
 * fee it carries instead.
 */
export function describeSavedCard(card: {
  brand: string | null;
  last4: string | null;
  exp_month?: number | null;
  exp_year?: number | null;
}): Pick<PaymentMethodDisplay, 'name' | 'brand' | 'expMonth' | 'expYear' | 'feeNote'> {
  const brandLabel = card.brand
    ? (CARD_BRAND_LABELS[card.brand.toLowerCase()] ?? card.brand)
    : 'Card';
  const isLinkBank = isLinkBankBrand(card.brand);
  return {
    name: isLinkBank ? LINK_BANK_CARD_NAME : `${brandLabel} •••• ${card.last4 ?? '••••'}`,
    brand: card.brand,
    expMonth: isLinkBank ? null : (card.exp_month ?? null),
    expYear: isLinkBank ? null : (card.exp_year ?? null),
    feeNote: isLinkBank ? `${LINK_BANK_FEE_LABEL} processing fee per payment` : null,
  };
}
